/* eslint-disable @typescript-eslint/no-var-requires */
import React, { lazy, Suspense } from 'react';
import { Root } from './styles';
import { cx } from '@linaria/core';
export const logoByChannel = Object.freeze({
    daserste: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/DasErsteBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/DasErsteBrandingAuto')),
    br: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/BrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/BrBrandingAuto')),
    hr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/HrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/HrBrandingAuto')),
    mdr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/MdrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/MdrBrandingAuto')),
    ndr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/NdrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/NdrBrandingAuto')),
    radiobremen: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/RadiobremenBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/RadiobremenBrandingAuto')),
    rbb: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/RbbBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/RbbBrandingAuto')),
    sr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/SrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/SrBrandingAuto')),
    swr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/SwrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/SwrBrandingAuto')),
    wdr: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/WdrBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/WdrBrandingAuto')),
    one: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/OneBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/OneBrandingAuto')),
    alpha: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/AlphaBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/AlphaBrandingAuto')),
    tagesschau24: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/Tagesschau24BrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/Tagesschau24BrandingAuto')),
    '3sat': process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/3SatBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/3SatBrandingAuto')),
    arte: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/ArteBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/ArteBrandingAuto')),
    kika: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/KikaBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/KikaBrandingAuto')),
    phoenix: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/PhoenixBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/PhoenixBrandingAuto')),
    dw: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/DeutschewelleBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/DeutschewelleBrandingAuto')),
    ard: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/ArdBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/ArdBrandingAuto')),
    zdf: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/ZdfBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/ZdfBrandingAuto')),
    funk: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/FunkBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/FunkBrandingAuto')),
    sportschau: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/SportschauBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/SportschauBrandingAuto')),
    deutschlandradio: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/DeutschlandradioBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/DeutschlandradioBrandingAuto')),
    ardaudiothek: process.env.NODE_ENV === NODE_ENV_TYPES.DEVELOPMENT
        ? require('../../assets/images/logos/svg/AudiothekBrandingAuto').default
        : lazy(() => import('../../assets/images/logos/svg/AudiothekBrandingAuto')),
});
export function ChannelLogo({ channel, className = '', width, height }) {
    const LogoComponent = logoByChannel[channel] ?? null;
    return (LogoComponent && (React.createElement(Suspense, { fallback: React.createElement("svg", null) },
        React.createElement(LogoComponent, { className: `${className} ${cx(Root.base, Root.globalColor)}`, width: width, height: height }))));
}
export default ChannelLogo;
